// planilla-mensual.model.ts
export class PlanillaMensual {
  idplanilla: number = null;
  anio: number = new Date().getFullYear();
  mes: number = new Date().getMonth() + 1;
  idsucursal: any = null;
  total_planilla: number = 0;
  observaciones: string = '';
  personalc_id: string = null;
  personalm_id: string = null;
  fecha_creacion: string = null;
  fecha_modificacion: string = null;
  activo: boolean = true;
  // campos de lectura
  sucursal_nombre: string = '';
  mes_nombre: string = '';
}
